export default "__VITE_ASSET__DHqQuZAu__"